angular.module('zc.zenclerkS')
  .component('zcsAgencySitesInInstallation', {
    templateUrl: '/templates/zenclerk_s/agencies/sites_in_installation/sites_in_installation.html',
    bindings: {
      agency: '<'
    },
    controller: zcsAgencySitesInInstallation,
  });


zcsAgencySitesInInstallation.$inject = ['$scope', '$stateParams', '$translate', 'AgencyProject'];
function zcsAgencySitesInInstallation($scope, $stateParams, $translate, AgencyProject) {
  const vm = this;

  // for CSV download
  vm.status = AgencyProject.projectStatuses;
  vm.data = [
    'apikey',
    'title',
    'company_name',
    'shopping_cart_asp',
    'cart_id',
    'base_url',
    'status',
    'status_last_updated_str',
    'status_num',
  ];
  vm.header = [
    'APIKEY',
    $translate.instant('agencies.sitesInInstallation.component.saito_na'),
    $translate.instant('agencies.sitesInInstallation.component.kaishamei'),
    $translate.instant('agencies.sitesInInstallation.component.kaato_asp'),
    $translate.instant('agencies.sitesInInstallation.component.kaato_id'),
    $translate.instant('agencies.sitesInInstallation.component.saito'),
    $translate.instant('agencies.sitesInInstallation.component.dounyuu_suteetasu'),
    $translate.instant('agencies.sitesInInstallation.component.dounyuu_suteetasu_koushin'),
    $translate.instant('agencies.sitesInInstallation.component.dounyuu_suteetasu_suuji'),
  ];

  vm.getCSV = getCSV;

  vm.$onInit = () => {
    AgencyProject.all($stateParams.agencyName)
      .then(projects => {
        projects = _.filter(projects, { product_line: 'zenclerk_s' });
        vm.projects = _.chain(projects)
          .reject(d => d.is_test || d.is_demo)
          .sortBy(d => -new Date(d.created_at))
          .each(AgencyProject.calculateProjectStatus)
          .value();
      });

  };

  function getCSV() {
    let csvData = _.map(vm.projects, p => _.pick(p, vm.data));
    _.each(csvData, p => {
      p.status_num = p.status;
      p.status = vm.status[p.status].name;
    });
    return csvData;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/sites_in_installation/sites_in_installation.component.js